import React from 'react'
import { LeftPart } from './DoorParts/LeftPart'
import { RightPart } from './DoorParts/RightPart'

export const DoubleDoors = ({ position = [0, 0, 0], rotation = 0, scale = 1, color }) => {
	return (
		<group position={position} scale={[scale, scale, 1.16 * scale]} rotation={[0, Math.PI / -2, 0]} castShadow receiveShadow>
			<LeftPart position={[0, 0, -12.5]} color={color} />
			<RightPart position={[0, 0, 12.5]} color={color} />
		</group>
	)
}
